import React from 'react';
import BattleFaceQuoteForm from './BattleFaceQuoteForm';

function App() {
  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f5f5f5', 
      paddingTop: '50px',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
    }}>
      <BattleFaceQuoteForm />
    </div>
  );
}

export default App;